import React from 'react'

import Flag from '@/legacy-src/components/Flag'
import Icon from '@/legacy-src/components/icons/Icon'
import { cn } from '@/legacy-src/lib/utils'
import { getTranslate } from '@/legacy-src/utilities/i18n'

type Props = {
  languages: string[]
  className?: string
}

const SpeaksLanguages: React.FC<Props> = ({ languages, className }) => {
  const { t } = getTranslate()

  if (!languages?.length) return null

  return (
    <div className={cn('flex items-center', className)}>
      <Icon icon="globe-rebrand" className="mr-2" />

      <span className="mr-2 text-sm font-bold">{t('therapistProfile.speaks')}</span>
      {languages.map((languageCode) => (
        <Flag languageCode={languageCode} key={languageCode} />
      ))}
    </div>
  )
}

export default SpeaksLanguages
